import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Tooltip } from 'antd'
import React from 'react'

const TooltipIconButton = ({ icon, iconColor, title, onClick = () => {} }) => {
  return (
    <Tooltip title={title}>
      <Button onClick={onClick}>
        <FontAwesomeIcon icon={icon} color={iconColor} />
      </Button>
    </Tooltip>
  )
}

export default TooltipIconButton
